// extracted by mini-css-extract-plugin
export default {"layout":"lWYdl","inner":"Ph8jB","actionText":"TErVZ","tabs":"Zd_YU","tabsText":"xxXz6","actions":"T6Wkf","toolbar":"R68n4"};